import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowListMember } from 'src/features/parkingManagement/types/allowList';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/allow-list-member/';

interface DTO extends ListDTO {
    parkingId: string;
    listId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, listId, ...params }: DTO): Promise<ListResponseSmartParkAPI<AllowListMember>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, listId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useListAllowListMembers, RESOURCE as LIST_ALLOW_LIST_MEMBERS_RESOURCE };
